import $ from 'jquery';

$(document).ready(() => {
  const $scrollBtn = $('.js-scroll-btn');

  if ($scrollBtn.length) {
    $scrollBtn.on('click', () => {
      $('html,body').animate({ scrollTop: $('.main-content').offset().top - 100 }, 'slow');
    });
  }
});
